module.exports = __webpack_public_path__ + "media/domenj/img-nosotros-header-7e20b975.png";